import { APP_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { ConfigLoaderService } from '@core/config-angular';

import { JourneyAnalyticsLoader } from './journey-analytics-loader.service';

function journeyAnalyticsFactory(
  configLoader: ConfigLoaderService,
  analyticsLoader: JourneyAnalyticsLoader
) {
  return async function initializeJourneyAnalytics() {
    const config = await configLoader.getConfigAsync();
    // Start up our SDK
    await analyticsLoader.load(config);
  };
}

/**
 * Provider that initializes the Journey Analytics instances.
 */
export const provideJourneyAnalytics = () =>
  makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: journeyAnalyticsFactory,
      deps: [ConfigLoaderService, JourneyAnalyticsLoader],
      multi: true,
    },
  ]);
